import React from 'react';
import {connect} from 'react-redux';

import {SearchCategory} from 'components/category-detail';
import ItemCategory from './ItemCategory.jsx';
import style from './style.scss';

class ListCategory extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <section className='center'>
        <div className="list-category-S">
          <h2 className='category-S-title'>Nhóm sản phẩm</h2>
          <div className='category-S-wrap-content'>
            <div className='category-S-left-list'>
              <div className='category-S-left-list-wrapper'>
                {
                  this.props.categories.map((item, i) => {
                    return (
                      <ItemCategory for="product" key={i} {...item}/>
                    );
                  })
                }
              </div>
            </div>
            <div className='category-S-right-filter'>
              <SearchCategory/>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

let bindStateToProps = (state) => {
  return {
    categories: state.categoriesAsTree
  };
};

export default connect(bindStateToProps)(ListCategory);



// WEBPACK FOOTER //
// ./components/list-category/ListCategory.jsx